import React, { useState } from 'react';
import { FastField } from 'formik';
import { Grid, Typography, Tooltip } from '@material-ui/core';

import FormSelect from '../../../components/FormSelect';
import useStyles from './styles';

const DropdownType = ({ label, name, options, level, readOnly }) => {
  const classes = useStyles({ level });
  const [open, setOpen] = useState(false);
  const createOptions = options.map(item => ({ label: item.text, value: item.id }));

  const handleMouseEnter = ({ currentTarget }) => {
    const labelEl = currentTarget.querySelector('label');
    if (labelEl?.scrollWidth > labelEl?.clientWidth) setOpen(true);
  };

  return (
    <Grid container spacing={1} justify="space-between" alignItems="center">
      <Grid item xs={8}>
        <Typography variant="subtitle2" gutterBottom className={classes.innerWrapper}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={4} className={classes.selectWrapper}>
        <Tooltip title={label} arrow placement="bottom" open={open} disableHoverListener disableFocusListener>
          <div onMouseEnter={handleMouseEnter} onMouseLeave={() => setOpen(false)}>
            <FastField
              name={name}
              label={label}
              component={FormSelect}
              options={createOptions}
              disabled={readOnly}
            />
          </div>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default DropdownType;
